import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AccountSuccessCodes } from '@app/translations';
import { FormID } from '@finxone-platform/form-action';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  ActionButtonOutcomesType,
  MaturityDecision,
  MaturityDecisionRequest,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { catchError, take, tap } from 'rxjs';
import { SavingsAccountService } from '../../../services/savings-account-service/savings-account.service';
import { WorkflowFormsService } from '../../../services/workflow-forms/workflow-forms.service';
import { FormActionState } from '../../../state/form-submision.state';
import { SavingsAccountState } from '../../../state/savings-account.state';
import { findAndShowAlertFromCode } from '../../alert-code-utils/alert-code.utils';
import { handleRedirection } from '../cta-redirection.utils';

export function submitMaturityDecisionRenew(injector: Injector, attri: UiZoneWidgetAttributeConfig) {
  const store = injector.get(Store);
  const alertHandlerService = injector.get(AlertHandlerService);
  const workflowFormsService = injector.get(WorkflowFormsService);
  const isValid = workflowFormsService.currentPageFormsValid();
  const activeAccount = store.selectSnapshot(SavingsAccountState.getCurrentAccount);
  const productCode: string | undefined = store.selectSnapshot(
    FormActionState.getFormActionStateWithId(FormID.MATURITY_DECISION),
  )?.formData?.renewalProductCode;

  if (!activeAccount?.accountId || !productCode) {
    alertHandlerService.showAlertFn('error', 'No active account or product code found');
    return;
  }

  if (!isValid) {
    console.warn('submitMaturityDecisionRenew: Current page form is invalid');
    return workflowFormsService.markCurrentPageFormsTouched();
  }

  const savingsAccountService = injector.get(SavingsAccountService);
  const router = injector.get(Router);
  const actionButtonNavigationConfigurations = attri.widgetProperties?.actionNavigationConfigurations;
  const payload: MaturityDecisionRequest = {
    decision: MaturityDecision.RENEW,
    productCode,
  };

  savingsAccountService
    .submitMaturityDecision(payload, activeAccount.accountId)
    .pipe(
      tap(() => {
        findAndShowAlertFromCode(store, router, alertHandlerService, [
          AccountSuccessCodes.MATURITY_DECISION_SUCCESS,
        ]);
        if (actionButtonNavigationConfigurations?.success) {
          handleRedirection(attri.widgetProperties, injector, ActionButtonOutcomesType.SUCCESS, true);
        }
      }),
      catchError((error) => {
        if (actionButtonNavigationConfigurations?.failure) {
          handleRedirection(attri.widgetProperties, injector, ActionButtonOutcomesType.FAILURE, true);
        }
        throw error;
      }),
      take(1),
    )
    .subscribe();
}
